import React, { useState, useEffect, useContext, createContext } from 'react';


import { DataContext } from '../../../init/getData';
import { PosCartContext } from '../../../init/posCartData';

import { Modal, Col, Form, Row, DropdownButton, Dropdown, InputGroup, Card } from 'react-bootstrap';
import { Button } from 'antd';

import toast from 'react-hot-toast';
import KeyPad from '../../../components/keyPad/keyPad';

export const selectedMissionContext = createContext();

function DiscountModal(props) {

  const { api, showModal, toggleModal, title, table, selectedIndex, selectedTab, refreshData, data } = props;
  const { tabData, setCart } = useContext(PosCartContext);

  const [loadingEffect, setLoadingEffect] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const { settingData, userRole } = useContext(DataContext);


  const cart = tabData[selectedTab].cart;

  
  const getCorrectIndex = () => {
    return settingData?.posItemReverse 
      ? cart.length - 1 - selectedIndex 
      : selectedIndex;
  };

  useEffect(() => {
    setInputValue("");
  }, [showModal]);


  const handleSubmit = () => {

    const discount = parseFloat(inputValue) || 0;

      if (discount > userRole.itemsDiscountLimit) {
        toast.error(`Maximum item discount allowed is ${userRole.itemsDiscountLimit}%`);
        return;
      }

    let updatedCart = [...cart];

    const correctIndex = getCorrectIndex();

    const item = updatedCart[correctIndex];

    updatedCart[correctIndex] = {
      ...updatedCart[correctIndex],
      priceDiscountPercentage: inputValue || 0,
      netPrice: (item.price - (item.price * inputValue / 100)),
      itemPrice: (item.price - (item.price * inputValue / 100)) / item.unitQuantity,
      totalPrice: (item.price - (item.price * inputValue / 100)) * (item.netQuantity),
      vatAmount: parseFloat((item.price - (item.price * inputValue / 100)) * item.vatPercentage / 100)

    }

    setCart(updatedCart, selectedTab);
    toggleModal();
  }

  return (
    <Modal show={showModal} onHide={toggleModal} backdrop='static' className='Delete_modal'>
      <Modal.Header style={{ background: "#1d7790" }} closeButton>
        <Modal.Title className="arabicText" style={{ color: "white" }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="arabicText">

        <Row className="mb-4">
          <Col>
            <Form.Control type='number' value={inputValue}
               onChange={e => {
                const value = e.target.value;
              
                // Allow empty string (so user can delete input)   
                if (value === "") {
                  setInputValue("");
                  return;
                }
              
                const numberValue = parseFloat(value);
              
                // Only show error if it's a valid number and exceeds limit
                if (!isNaN(numberValue) && numberValue > userRole.itemsDiscountLimit) {
                  toast.error(`Maximum item discount allowed is ${userRole.itemsDiscountLimit}%`);  
                  return;
                }
              
                setInputValue(value);
              }}
              onKeyDown={(e) => { if (e.key === 'Enter') { handleSubmit() } }}
              autoFocus />
               {userRole?.itemsDiscountLimit && (
              <div className="text-muted mt-1">
                Max discount: {userRole.itemsDiscountLimit}%
              </div>
            )}
          </Col>
        </Row>

        <Row>
          <Col md={2}>
          </Col>
          <Col md={8}>
            <KeyPad
              setInputValue={setInputValue}
              inputValue={inputValue}
            />
          </Col>
          <Col md={2}>
          </Col>
        </Row>

      </Modal.Body>
      <Modal.Footer>
        <div>
          <Button type="primary" size="large" loading={loadingEffect} onClick={handleSubmit}
            style={{ marginLeft: '10px', backgroundColor: '#1d7790' }} danger>Done</Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default DiscountModal;
